/** A crypto source instead of `Math.random` - test data needs no entropy, but Sonar flags the PRNG. */
const randomFraction = () => self.crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32;

export const randomInt = (min: number, max: number) =>
  min + Math.floor(randomFraction() * (max - min + 1));

export const randomOf = <T>(values: readonly T[]): T => values[randomInt(0, values.length - 1)];

export const randomDigits = (length: number) =>
  Array.from({ length }, () => randomInt(0, 9)).join('');

const LETTERS = [...'abcdefghijklmnopqrstuvwxyz'];

export const randomWord = (minLength: number, maxLength: number) => {
  const [first, ...rest] = Array.from({ length: randomInt(minLength, maxLength) }, () =>
    randomOf(LETTERS),
  );

  return [first.toUpperCase(), ...rest].join('');
};

export const randomPhoneNumber = () => `0${randomDigits(9)}`;
